import { BaseFetch } from "../main-model"
export default class OrgChartModel extends BaseFetch {
  getOrgChartById = (data) =>
  this.authFetch({
    url: "org-chart/getOrgChartById",
    method: "POST",
    body: JSON.stringify(data),
  })
  insertOrgChart = (data) =>
    this.authFetch({
      url: "org-chart/insertOrgChart",
      method: "POST",
      body: JSON.stringify(data),
    })
   
}
